import React, { useState, useContext, useEffect } from "react";
import styled, { css } from 'styled-components';

import {
  CssTableLine,
  CssSwitchSub,
  CssTableCountry,
  CssTableFlag,
  CssTableDays,
  CssInputDay,
  SelectSquare,
  PAinfoCollapsible,
} from '../uikit2';

import {
  InputCopy,
  FormGroup,
  Dropdown,
  FormFooter,
  Select,
  Tooltip,
  StatusDot,
  ContentBlock,
  Breadcrumbs,
  Checkbox,
  Subheader,
  Pill,
  Collapse,
  Button,
  Card,
  Input,
  RadioGroup,
  Icon,
  Popover,
  ButtonAction,
  Tag,
  Notification
} from "xsolla-uikit";


import { Reset } from "./Reset";


export const PAgcGKcountryLine = ({
  defCurr,
  defPrice,
  key = 0,
  ind = 0,
  cur = "max",
  oneCurr,
  handleChange = () => {
    void 0;
  }
}) => {
  const [current, setCurrent] = useState(cur || "defaultPeriod");

  const [inp, setInp] = useState(oneCurr[cur]);
  const handleFocus = event => event.target.select();
  let timeOut;

  // useEffect(() => {
  //   // debugger
  //   if (cur === current) {
  //     if (inp > oneCurr["max"]) {
  //       timeOut = setTimeout(() => {
  //         setCustom(oneCurr["max"]);
  //       }, 500);
  //     }

  //     if (inp < oneCurr["min"]) {
  //       timeOut = setTimeout(() => {
  //         setCustom(oneCurr["min"]);
  //       }, 500);
  //     }
  //   }

  //   return () => {
  //     timeOut && clearTimeout(timeOut);
  //   };
  // });

  // useEffect(() => {
  //   if (inp !== oneCurr[current]) {
  //     handleChange("defaultPeriod");
  //   }
  // }, [inp]);

  // useEffect(() => {
  //   setCustom(oneCurr[current]);
  // }, [current]);

  // useEffect(() => {
  //   if (cur !== current) {
  //     console.log("cur = ", cur);
  //     console.log("current = ", current);
  //     setCurrent(cur);
  //   }
  // }, [cur, current]);

  // const setCustom = val => {
  //   setInp(val);
  //   gcCountries[ind]["defaultPeriod"] = val;
  // };

  return (
    <CssTableLine key={ind}>
      <CssTableCountry style={{width: 244}}>
        {oneCurr["name"]}
      </CssTableCountry>

<CssTableInput>
      <CssTableCurr>{oneCurr["symbol"]}</CssTableCurr>
      <Input
          disabled={oneCurr["code"] === defCurr ? true : false}
          key='1'
          size="sm"
          input={{
            name: '1',
            value: oneCurr["code"] === defCurr ? defPrice : parseFloat(defPrice * oneCurr['name'].length/10).toFixed(2),
            // onFocus: handleFocus,
            // onChange: e => {
            //   let val = e.target.value;
            //   setInp(val);
            // }
          }}
        />
</CssTableInput>



          <Reset
            icon='redo'
            title =""
            labels = {
              [{
                title: <span>Reset to recommended: {oneCurr['symbol']}&thinsp;{oneCurr["code"] === defCurr ? defPrice : parseFloat(defPrice * oneCurr['name'].length/10).toFixed(2)}</span>,
                description: <span><p>The recommended price is calculated according to a median game price in {oneCurr['icon']}&thinsp;<b>{oneCurr['name']}</b></p>
                <p>1 USD = {oneCurr['symbol']} 43.22 (<a href="#">source</a>)</p>
                </span>,
              }]
            }
            // handleChange ={(newch)=>{
            // }}
          />





    </CssTableLine>
  );
};


const CssTableInput = styled.div`
  margin-right: 10px;
  position: relative;
  z-index: 0;
  & input,
  & input:hover,
  & input:active,
  & input:focus {
    width: 120px;
    padding: 6px 12px 6px 54px;
    z-index: 0;
    position: relative;
  }
`

const CssTableCurr = styled.span`
  font-size: 0.8em;
  position: absolute;
  display: flex;
  text-transform: uppercase;
  justify-content: center;
  font-weight: bolder;
  margin-right: 16px;
  min-width: 44px;
  min-height: 32px;
  align-items: center;
  top: 2px;
  left: 2px;
  text-align: center;
  background-color: #f2f3f7;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  z-index: 1;
`